import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Popup.module.scss';

interface PopupProps {
  onClose: () => void; // Функция для закрытия попапа
}

const Popup: React.FC<PopupProps> = ({ onClose }) => {
  const { t } = useTranslation();

  // Отключаем скролл на боди, пока попап открыт
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  // Клик по фону (оверлею) закрывает попап
  const handleOverlayClick = () => {
    onClose();
  };

  // Клик внутри содержимого попапа не должен его закрывать
  const handlePopupClick = (event: React.MouseEvent) => {
    event.stopPropagation();
  };

  return (
    <div className={styles.overlay} onClick={handleOverlayClick}>
      <div className={styles.popup} onClick={handlePopupClick}>
        {/* Кнопка-крестик для закрытия */}
        <button className={styles.closeBtn} onClick={onClose}>
          &times;
        </button>

        {/* Контент попапа */}
        <p>
          {t('popup.text')}{' '}
          <a
            href="https://t.me/proxyflashBot"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('popup.linkText')}
          </a>
        </p>
      </div>
    </div>
  );
};

export default Popup;
